import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { DateStringPipe } from '../core/pipes/date-string-pipe/date-string.pipe';
import { DecodeStringPipe } from '../core/pipes/decode-string-pipe/decode-string.pipe';
import { FormatDateAndTimePipe } from '../core/pipes/format-date-and-time-pipe/format-date-and-time.pipe';
import { FormatUrlForBackgroundImagePipe } from '../core/pipes/format-url-for-background-image-pipe/format-url-for-background-image-pipe';
import { TransformItineraryDatePipe } from '../core/pipes/transform-itinerary-date-pipe/transform-itinerary-date.pipe';
import { TrustpilotVisibilityResolver } from '../core/resolvers/trustpilot-visibility-resolver/trustpilot-visibility.resolver';
import { AngularMaterialModule } from './angular-material.module';
import { AutocompleteInputComponent } from './components/autocomplete-input/autocomplete-input.component';
import { LoadingComponent } from './components/loading/loading.component';
import { EventDirective } from './directives/event.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ButtonLoadingComponent } from './components/button-loading/button-loading.component';
import { FormControlErrorsPipe } from '../core/pipes/form-control-errors-pipe/form-control-errors.pipe';
import { ErrorMessagesBoxComponent } from './components/error-messages-box/error-messages-box.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { ClickableLinksPipe } from '../core/pipes/clickable-links-pipe/clickable-links-pipe';
import { SignInBarComponent } from './components/sign-in-bar/sign-in-bar.component';
import { RoomTypesPipe } from '../core/pipes/room-type/room-types.pipe';
import { LazyImageDirective } from './directives/lazy-image/lazy-image.directive';
import { TitleOnOverflowDirective } from './directives/title-on-overflow.directive';
import { BadgeComponent } from './components/badge/badge.component';
import { ButtonComponent } from './components/button/button.component';
import { FileOpenerDirective } from './directives/file-opener/file-opener.directive';
import { DocumentToDownloadFileOptionsPipe } from './pipes';
import { DisabledWhileOfflineDirective } from './directives/disabled-while-offline/disabled-while-offline.directive';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PlanistoLinkOpenerDirective } from './directives/planisto-link-opener';
import { ButtonLoadingContentDirective, ButtonLoadingDirective } from './directives/button-loading';
import { DocumentProcessorDirective } from './directives/file-opener/file-processor/document/document-processor.directive';
import { ButtonDirective } from './directives';
import { RefresherComponent } from './components/refresher/refresher.component';
import { RefresherErrorMessageComponent } from './components/refresher/refresher-error-message/refresher-error-message.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    AngularMaterialModule,
    MatIconModule,
    ReactiveFormsModule,
    LoadingComponent,
    DateStringPipe,
    AutocompleteInputComponent,
    FormControlErrorsPipe,
    ButtonLoadingComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    TitleOnOverflowDirective,
    EventDirective,
    ErrorMessagesBoxComponent,
    FileOpenerDirective,
    DocumentToDownloadFileOptionsPipe,
    DisabledWhileOfflineDirective,
    ErrorPageComponent,
    ButtonLoadingDirective,
    ButtonLoadingContentDirective,
    DocumentProcessorDirective,
    ButtonDirective,
    RefresherComponent,
    RefresherErrorMessageComponent,
    PlanistoLinkOpenerDirective,
  ],
  declarations: [
    FormatDateAndTimePipe,
    TransformItineraryDatePipe,
    DecodeStringPipe,
    ClickableLinksPipe,
    FormatUrlForBackgroundImagePipe,
    TooltipDirective,
    SignInBarComponent,
    RoomTypesPipe,
    LazyImageDirective,
    BadgeComponent,
    ButtonComponent,
  ],
  exports: [
    CommonModule,
    EventDirective,
    LoadingComponent,
    FormatDateAndTimePipe,
    DateStringPipe,
    TransformItineraryDatePipe,
    DecodeStringPipe,
    ClickableLinksPipe,
    AngularMaterialModule,
    MatIconModule,
    ReactiveFormsModule,
    FormatUrlForBackgroundImagePipe,
    ButtonLoadingComponent,
    AutocompleteInputComponent,
    FormControlErrorsPipe,
    ErrorMessagesBoxComponent,
    TooltipDirective,
    SignInBarComponent,
    RoomTypesPipe,
    LazyImageDirective,
    NgxMaskDirective,
    TitleOnOverflowDirective,
    RoomTypesPipe,
    LazyImageDirective,
    BadgeComponent,
    ButtonComponent,
    ButtonComponent,
    FileOpenerDirective,
    DocumentToDownloadFileOptionsPipe,
    DisabledWhileOfflineDirective,
    ErrorPageComponent,
    PlanistoLinkOpenerDirective,
    ButtonLoadingDirective,
    ButtonLoadingContentDirective,
    DocumentProcessorDirective,
    ButtonDirective,
    RefresherComponent,
    RefresherErrorMessageComponent,
    ButtonDirective,
  ],
  providers: [DatePipe, DecimalPipe, TrustpilotVisibilityResolver, provideNgxMask()],
})
export class SharedModule {}
